export const increaseCounter = (payload) => {
  return {
    type: "increaseCounter",
    payload
  }
}
export const decreaseCounter = (payload) => {
  return {
    type: "decreaseCounter",
    payload
  }
}